import Vue from 'vue'
import Router from 'vue-router'
import Invitation from './views/Invitation.vue'
import Success from './views/Success.vue'
import Admin from './views/Admin.vue'
import Condominiums from './views/Condominiums.vue'
import CondominiumList from './views/CondominiumList.vue'
import CondominiumProfile from './views/CondominiumProfile.vue'
import AccessPoints from './views/AccessPoints.vue'
import AccessPointList from './views/AccessPointList.vue'
import Accesses from './views/Accesses.vue'
import Delegations from './views/Delegations.vue'
import DelegationList from './views/DelegationList.vue'
import DelegationProfile from './views/DelegationProfile.vue'
import AccessProfile from './views/AccessProfile.vue'
import AccessPointProfile from './views/AccessPointProfile.vue'
import AccessList from './views/AccessList.vue'
import Login from './views/Login.vue'
import LostPassword from './views/LostPassword.vue'
import NewPassword from './views/NewPassword.vue'
import Users from './views/Users.vue'
import UserList from './views/UserList.vue'
import UserProfile from './views/UserProfile.vue'
import Openings from './views/Openings.vue'
import Guard from './middlewares/guard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/invitation/:token',
      name: 'invitation',
      beforeEnter: Guard.isNotAuth,
      component: Invitation
    },
    {
      path: '/invitation/success',
      name: 'success',
      beforeEnter: Guard.isNotAuth,
      component: Success
    },
    {
    path: '/validation/:number',
      name: 'validateNumber',
      component: Openings,
      beforeEnter: Guard.isNotAuth,
      meta: {
        breadcrumb: 'Partage de code'
      },
    },
    {
      path: '/bo',
      name: 'admin',
      component: Admin,
      redirect: { name: 'sites' },
      beforeEnter: Guard.auth,
      children: [
        {
          path: 'condominiums',
          // name: 'site',
          component: Condominiums,
          meta: {
            breadcrumb: 'Sites'
          },
          children: [
            {
              path: '',
              name: 'sites',
              component: CondominiumList,
            },
            {
              path: ':condominiumId',
              name: 'condominiumProfile',
              component: CondominiumProfile,
              meta: {
                breadcrumb: 'Profil Site'
              },
            },
          ]
        },
        {
          path: 'users',
          // name: 'users',
          component: Users,
          meta: {
            breadcrumb: 'Utilisateurs'
          },
          children: [
            {
              path: '',
              name: 'utilisateurs',
              component: UserList,
            },
            {
              path: ':userId',
              name: 'userProfile',
              component: UserProfile,
              meta: {
                breadcrumb: 'Profil Utilisateur'
              },
            },
          ]
        },
        {
          path: 'accesspoints',
          // name: 'boitiers',
          component: AccessPoints,
          beforeEnter: Guard.admin,
          meta: {
            breadcrumb: 'Boitiers'
          },
          children: [
            {
              path: '',
              name: 'boitiers',
              component: AccessPointList,
              beforeEnter: Guard.auth,
            },
            {
              path: ':accessPointId',
              name: 'accessPointProfile',
              component: AccessPointProfile,
              meta: {
                breadcrumb: 'Profil Boîtier'
              },
            },
          ]
        },
        {
          path: 'delegations',
          component: Delegations,
          meta: {
            breadcrumb: 'Délégations'
          },
          children: [
            {
              path: '',
              name: 'delegations',
              component: DelegationList,
              beforeEnter: Guard.auth,
            },
            {
              path: ':delegationId',
              name: 'delegationProfile',
              component: DelegationProfile,
              meta: {
                breadcrumb: 'Profil Délégation'
              },
            },
          ]
        },
        {
          path: 'accesses',
          component: Accesses,
          meta: {
            breadcrumb: 'Groupes'
          },
          children: [
            {
              path: '',
              name: 'badges',
              component: AccessList,
              beforeEnter: Guard.auth,
            },
            {
              path: ':accessId',
              name: 'accessProfile',
              component: AccessProfile,
              meta: {
                breadcrumb: 'Profil groupe'
              },
            },
          ]
        },
      ]
    },

    {
      path: '/bo/login',
      name: 'login',
      component: Login
    },
    {
      path: '/bo/password/lost',
      name: 'lost-password',
      component: LostPassword
    },
    {
      path: '/bo/password/new/:resetPasswordToken',
      name: 'new-password',
      component: NewPassword
    },
    {
      path: '*',
      redirect: { name: 'sites' }
    }
  ]
})
